<template>
    <div class="add-to-cart-bottom">
        <div class="container p-0">
            <nav>
                <li class="kts-product-descripttion" v-if="checkCurrent && paymentPlan.length > 0"
                    :class="{ active: preFaqActive }" id="kts-product-descripttion-pre">
                    <a class="open-meta" @click="togglePreFaq">
                        <span class="text product-details-title">Instalment Plans + Promotions</span>
                        <span class="home-faqs__item-title--icon">
                            <span class="home-faqs__icon home-faqs__icon--a"></span>
                            <span class="home-faqs__icon home-faqs__icon--b"></span>
                        </span>
                    </a>
                    <div class="product-meta" :style="{
                        height: preFaqActive ? preFaqHeight : '0',
                        padding: preFaqActive ? '20px' : '0 20px',
                        overflow: 'hidden',
                    }">
                        <table class="instalment-payments-tb">
                            <tbody>
                                <tr v-for="item in paymentPlan">
                                    <td class="logo-cell-td">
                                        <p><img :src="`${baseUrl}api/wp-content/uploads/${item.image}`" alt="payment" />
                                        </p>
                                    </td>
                                    <td class="details-cell-td">
                                        <div class="grab-price-divider-widget">
                                            <p>{{ item.title }}
                                                <span v-if="item.type == 'grab'"
                                                    v-html="displayCustomPrice((priceGrab / 4).toFixed(2).toString(), true)"></span>
                                                <span v-else
                                                    v-html="displayCustomPrice((priceGrab / 3).toFixed(2).toString(), true)"></span>
                                            </p>
                                            <a v-if="item.type == 'grab'" class="mb-divide" @click="openModalGrab">More
                                                Info</a>
                                            <div v-html="htmlSpecialcharsDecode(item.content)"> </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </li>
                <template v-for="(description, index) in getDescriptionList()" :key="`desc-${index}`">
                    <li v-if="description.option_value" class="kts-product-descripttion"
                        :class="{ active: activeFaq.has(index as number) }" :id="`kts-product-descripttion${index}`">
                        <a class="open-meta" @click="showFaqItemContent(index as number)">
                            <h2 class="text product-details-title">{{ descriptionLabels[index as number].option_name }}
                            </h2>
                            <span class="home-faqs__item-title--icon">
                                <span class="home-faqs__icon home-faqs__icon--a"></span>
                                <span class="home-faqs__icon home-faqs__icon--b"></span>
                            </span>
                        </a>
                        <div class="product-meta" :style="{
                            height: activeFaq.has(index as number) ? heights[index as number] : '0',
                            padding: activeFaq.has(index as number) ? '20px' : '0 20px',
                            overflow: 'hidden',
                        }" v-html="convertUrlsToLocale(description.option_value, baseUrl, locale)">
                        </div>
                    </li>
                </template>
                <div :class="['grab_pdt_div_modal', { open: isModalGrabOpen }]" @click="handleOutsideClick">
                    <div class="grab_pdt_container_modal">
                        <div class="grab_pdt_action_bar"><a class="grab_pdt_action_close" @click="closeModalGrab">x</a>
                        </div>
                        <div class="grab_pdt_container_row_1">
                            <img src="/single-product/logograb.svg" alt="Grab">
                        </div>
                        <div class="grab_pdt_container_row_2">
                            <p>With PayLater, get what you need now and pay later</p>
                        </div>
                        <div class="grab_pdt_container_row_3">
                            <ul class="grab_pdt_features">
                                <li>
                                    <img src="/single-product/grab01.svg" alt="Spread your bill without interest">
                                    <h5>Spread your bill without interest</h5>
                                    <p>With 4 monthly interest-free instalments, we give you more time to pay in smaller
                                        amounts.</p>
                                </li>
                                <li>
                                    <img src="/single-product/grab02.svg" alt="No hidden charges, free to use">
                                    <h5>No hidden charges, free to use</h5>
                                    <p>Automatic repayments ensures you won't miss any payments.</p>
                                </li>
                                <li>
                                    <img src="/single-product/grab03.svg" alt="Fast and secure Checkout in 2 taps">
                                    <h5>Fast and secure Checkout in 2 taps.</h5>
                                    <p>Set up in 2 minutes without having to save card details on multiple shopping
                                        sites anymore.</p>
                                </li>
                            </ul>
                        </div>
                        <div class="grab_pdt_container_row_4"><a class="grab_pdt_action_learnmore"
                                href="https://www.grab.com/finance/pay-later" target="_blank">Learn more</a></div>
                    </div>
                </div>
            </nav>
        </div>
    </div>
    <div class="time_shipping" style="display: none;">
        <p class="time_exp">{{ timeExpressShipping }}</p>
        <p class="time_free">{{ timefreeShipping }}</p>
    </div>
</template>

<style lang="scss">
@import "@/assets/scss/components/product/_cartbottom.scss";
</style>

<script setup lang="ts">
import { displayCustomPrice, displayPrice } from "~/utils/displayPrice"
import { expressShipping, freeShipping } from '~/assist/TimeShipping';

interface MappedDescription {
    option_name: string;
    option_value: string;
}
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { convertUrlsToLocale } from '~/utils/getLangUrl';
const wooStore = useWooStore();
const props = defineProps(["data", "priceInfo", "paymentPlan", "isCustomise", "date_delivery", "date_collection"]);
import { calculateShippingEndDate, calculateShippingStartDate } from '~/assist/ShippingDateCalculator';

const productDescription = computed(() => props.data);
const priceGrab = props.priceInfo?.price ?? '0';
const paymentPlan = props.paymentPlan ?? [];
const dateDelivery = computed(() => props.date_delivery);
const dateCollection = computed(() => props.date_collection);
const descriptionLabels = ref([
    {
        option_name: "Details + Dimensions",
        option_slug: "description"
    },
    {
        option_name: "Specifications",
        option_slug: "specifications"
    },
    {
        option_name: props.isCustomise ? "Customisation Lead Time" : "Delivery Policy",
        option_slug: props.isCustomise ? "options_customise_delivery_shipping" : "options_delevery_&_shipping"
    },
    // { option_name: "Care + Maintenance", option_slug: "options_care_&_maintenance"},
    {
        option_name: props.isCustomise ? "Guaranteed Quality" : "7 Days Exchange Policy",
        option_slug: props.isCustomise ? "options_cutomise_exchange_policy" : "options_exchange_policy"
    }
]);


const mappedDescriptions = computed<MappedDescription[]>(() => {
    return descriptionLabels.value.map(label => {
        const matchedDescription = productDescription.value.find((desc: any) => desc.option_name === label.option_slug.toLowerCase().replace(/\s+/g, '_'));
        return {
            option_name: label.option_name,
            option_value: matchedDescription ? autop(matchedDescription.option_value) : '',
        };
    });
});

const getDescriptionList = () => mappedDescriptions.value as MappedDescription[];

const activeFaq = ref<Set<number>>(new Set([0]));
const heights = ref<Record<number, string>>({});
const preFaqHeight = ref<string>('');
const preFaqActive = ref(false);
const isModalGrabOpen = ref(false);

const valueCurrency = ref('');
const checkCurrent = ref(false);
const timeExpressShipping = ref('');
const timefreeShipping = ref('');
interface ShippingData {
    shippingStartDay?: string;
    shippingDay: string;
    publicHolidays: string[];
    preOrderType: string;
    preOrderDay: string;
    preOrderDate: string;
}
    watch(dateDelivery, (dateDelivery) => {
        if (dateDelivery) {
            const shippingDataClone = { ...dateDelivery } as ShippingData;
            const shippingEndDataFormat = calculateShippingEndDate(shippingDataClone);
            const shippingStartDateFormat = calculateShippingStartDate(shippingDataClone);
            // timeExpressShipping.value = 'Usually ships out in ' + shippingStartDateFormat + ' - ' + shippingEndDataFormat + ' working days*';
            timeExpressShipping.value = shippingStartDateFormat + ' - ' + shippingEndDataFormat ;
        }
    }, { immediate: true });
    watch(dateCollection, (dateCollection) => {
        if (dateCollection) {
            const shippingDataClone = { ...dateCollection } as ShippingData;
            const shippingEndDataFormat = calculateShippingEndDate(shippingDataClone);
            const shippingStartDateFormat = calculateShippingStartDate(shippingDataClone);
            // timefreeShipping.value = 'Usually ready in ' + shippingStartDateFormat + ' – ' + shippingEndDataFormat + ' working days*';
            timefreeShipping.value = shippingStartDateFormat + ' – ' + shippingEndDataFormat ;
        }
    }, { immediate: true });

const openModalGrab = () => {
    isModalGrabOpen.value = true;
    document.body.style.overflow = 'hidden';
};
const closeModalGrab = () => {
    isModalGrabOpen.value = false;
    document.body.style.overflow = '';
};
const handleOutsideClick = (event: any) => {
    const modalContent = document.querySelector('.grab_pdt_container_modal');
    if (modalContent && !modalContent.contains(event.target)) {
        closeModalGrab();
    }
};

const calculateHeights = (index: number, expand = false) => {
    const element = document.querySelector(`#kts-product-descripttion${index} .product-meta`) as HTMLElement;
    if (element) {
        const baseHeight = element.scrollHeight;
        heights.value[index] = expand ? `${baseHeight + 40}px` : `${baseHeight}px`;
    }
};


const togglePreFaq = () => {
    preFaqActive.value = !preFaqActive.value;
}
const showFaqItemContent = (index: number) => {
    const selectedFaqs = document.querySelector(`#kts-product-descripttion${index}`);
    if (selectedFaqs) {
        selectedFaqs.classList.toggle('active');
    }

    if (activeFaq.value.has(index)) {
        activeFaq.value.delete(index);
        heights.value[index] = '0';
    } else {
        activeFaq.value.add(index);
        calculateHeights(index, true);
    }
};

const updateCurrencyStatus = () => {
    // valueCurrency.value = getCookie("altcs_detect_country") ?? '';
    valueCurrency.value = wooStore.currency.currency;
    checkCurrent.value = valueCurrency.value === 'MYR';
};

const setHeightPayment = () => {
    if (process.client) {
        const element = document.querySelector(`#kts-product-descripttion-pre > .product-meta .instalment-payments-tb`) as HTMLElement | null;
        if (element) {
            const setHeight_payment = element.offsetHeight;
            preFaqHeight.value = setHeight_payment > 0 ? `${setHeight_payment + 40}px` : `0px`;
        }
    }
}

onMounted(() => {
    calculateHeights(0);
    updateCurrencyStatus();
    setTimeout(() => {
        setHeightPayment();
        changeTimeShipping();
    }, 500);

});
watchEffect(() => {
    updateCurrencyStatus();
    setTimeout(() => {
        setHeightPayment();
    }, 500);
});


const changeTimeShipping = () => {
        const free_ship = document.querySelector('.custom_delivery .left_ct.cs_form');
        const time_exp = document.querySelector('.custom_delivery .right_ct.cs_form');
        const new_text_free_ship = document.querySelector('.time_shipping .time_free')?.textContent;
        const new_text_exp_ship = document.querySelector('.time_shipping .time_exp')?.textContent;

        if (free_ship && new_text_exp_ship) {
            const codeElement = free_ship.querySelector('.custom_code_delivery');
            if (codeElement) {
                codeElement.textContent = new_text_exp_ship;
            }
        }
        if (time_exp && new_text_free_ship) {
            const codeElement = time_exp.querySelector('.custom_code_collection');
            if (codeElement) {
                codeElement.textContent = new_text_free_ship;
            }
        }
    }

const autop = (text: string) => {
    let output = text
        .replace(/\r\n|\r/g, '\n')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/?p>/gi, '\n\n')
        .trim();

    // Replace multiple newlines with double newlines
    output = output.replace(/\n\s*\n/g, '\n\n');

    // Split into blocks
    const blocks = output.split(/\n\n+/);
    const allblocks = '(?:table|thead|tfoot|caption|col|colgroup|tbody|tr|td|th|div|dl|dd|dt|ul|ol|li|pre|form|map|area|blockquote|address|style|p|h[1-6]|hr|fieldset|legend|section|article|aside|hgroup|header|footer|nav|figure|figcaption|details|menu|summary)';

    // Process each block
    output = blocks
        .map(block => {
            // Skip if block is just whitespace
            if (!block.trim()) return '';

            // Handle preformatted blocks
            if (block.startsWith('<pre') || block.startsWith('<script') ||
                block.startsWith('<style') || block.startsWith('<code')) {
                return block;
            }

            // Replace single newlines with <br />
            let content = block.replace(/\n/g, '<br />\n');

            // Wrap in paragraphs if not already wrapped in HTML tags
            if (!/^<(?:[a-z][a-z0-9]*)\b[^>]*>/i.test(block)) {
                content = `<p>${content}</p>`;
            }

            return content;
        })
        .join('\n\n');

    output = output.replace(new RegExp(`(<\\/?(?:${allblocks})[^>]*>)\\s*<br \\/>`, 'gi'), '$1');
    output = output.replace(new RegExp(`<br \\/>(\\s*<\\/?(?:${allblocks})[^>]*>)`, 'gi'), '$1');
    output = output.replace(/\n<\/p>$/, '</p>');

    // Remove any empty <p> tags
    output = output.replace(/<p>\s*<\/p>/g, '');

    // Preserve line breaks after lists, blockquotes, and div tags
    output = output.replace(/(<(?:ul|ol|blockquote|div)[^>]*>)\s*<br \/>/g, '$1');

    return output;
}


</script>